<template>
  <section v-if="items && items.length" class="top-picks">
    <div class="header">
      <span v-if="icon" class="header-icon">{{ icon }}</span>
      <h2>{{ title }}</h2>
    </div>

    <div class="pick-list">
      <div class="pick-card" v-for="(item, index) in items" :key="item.product_detail_id || item.product_id || index">
        <div class="image-wrapper">
          <img
            :src="item.photo || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'"
            :alt="item.name" />
        </div>

        <div class="card-body">
          <p class="name">{{ item.name }}</p>
          <div class="footer">
            <span class="price">{{ formatPrice(item.price_sell) }}</span>
            <div v-if="!isInCart(item.product_detail_id)">
              <button @click="addToCart(item)" class="add-btn">+</button>
            </div>
            <div v-else class="status-out">
              <span>
                Added
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TopPick",
  props: {
    title: {
      type: String,
      default: "Top Picks",
    },
    icon: {
      type: String,
      default: "🔥",
    },
    items: {
      type: Array,
      required: true
    },
    isInCart: {
      type: Function,
      required: true
    }
  },
  emits: ["add-product"],
  methods: {
    addToCart(product) {
      this.$emit("add-product", product)
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0
      }).format(price)
    },
  }
}
</script>

<style scoped>
.top-picks {
  margin: 0 0;
}

.status-out {
  font-size: 0.8rem;
  color: #b2bec3;
  font-style: italic;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  /* margin-bottom: 4px; */
}

.header h2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1f2937;
}

.header-icon {
  font-size: 1.2rem;
}

.pick-list {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
  scroll-snap-type: x mandatory;
}

.pick-list::-webkit-scrollbar {
  display: none;
}

.pick-card {
  min-width: 140px;
  max-width: 140px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  scroll-snap-align: start;
}

.image-wrapper {
  width: 100%;
  height: 100px;
  overflow: hidden;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-body {
  padding: 10px;
}

.name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #111827;
  line-height: 1.2;
  margin-bottom: 8px;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price {
  font-size: 0.85rem;
  font-weight: 700;
  color: #dc2626;
}

.add-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #fee2e2;
  color: #dc2626;
  font-size: 1.1rem;
  font-weight: 700;
}

/* Mobile kecil */
@media (max-width: 360px) {
  .pick-card {
    min-width: 120px;
  }
}
</style>
